var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInventoryVisibility = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "M18.2 6.7c-.2 0-.4-.1-.5-.3l-1.1-2.6 2.7-1.2c.3-.1.5 0 .7.2.1.3 0 .5-.2.7l-1.8.8.6 1.7c.1.3 0 .5-.3.7z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "M18.2 19.6c-.2 0-.4-.1-.4-.3-.1-.2 0-.5.2-.7 3.9-1.9 5.5-6.6 3.6-10.5-.7-1.5-1.9-2.6-3.3-3.4l-.8-.2c-.3-.1-.4-.4-.3-.6.1-.3.4-.4.6-.3l.9.3c1.7.9 3 2.2 3.8 3.9 2.2 4.4.4 9.7-4 11.8z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M14 16.4c-.2 0-.3-.1-.4-.3s-.1-.5.2-.7l4.2-2.3c.2-.1.5-.1.7.2.1.2.1.5-.2.7l-4.2 2.3c-.1.1-.2.1-.3.1M5.7 18.3c-.1 0-.2 0-.3-.1l-2.1-1.3c-.2-.1-.3-.5-.2-.7.2-.2.5-.3.7-.2l2.1 1.3c.2.1.3.5.2.7s-.2.3-.4.3"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M10.9 23.5c-.4 0-.8-.1-1.1-.3h-.1l-4.3-2.5-2.1-1.3c-.5-.3-.7-.8-.7-1.3V11c0-.8.4-1.5 1.1-1.9l7.7-4.2c.1 0 .1-.1.2-.1.1-.1.1-.1.2-.1.5-.1.9.1 1.4.4l1.5.9 4.6 2.8c.7.4 1.1 1.1 1.1 1.9v6.9l-.1.8-2.3 1.4-6 3.5c-.2.1-.4.2-.6.2zm1.3-17.9c-.1 0-.1 0-.2.1L4.2 9.9c-.4.2-.6.6-.6 1V18c0 .2.1.4.3.5L6 19.8l4.3 2.6c.3.2.6.2.9.1.1 0 .2-.1.3-.1l6-3.4 1.9-1.2v-7c0-.4-.2-.8-.6-1.1l-6.1-3.8c-.2-.2-.4-.3-.5-.3"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M15.5 12.5c-.1 0-.2 0-.3-.1L8.1 7.7c-.3-.2-.3-.5-.2-.7.2-.2.5-.3.7-.1l7.2 4.7c.2.2.3.5.1.7 0 .1-.2.2-.4.2"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "m11.2 14.9-7.8-4.5c-.2-.1-.2-.4-.1-.6s.4-.4.7-.2l7.3 4.2 8.2-4.3c.2-.1.5 0 .7.2.1.2 0 .5-.2.7z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M10.9 23.2c-.3 0-.5-.2-.5-.5v-8.5c0-.3.2-.5.5-.5s.5.2.5.5v8.5c0 .3-.2.5-.5.5"
})));
export default SvgInventoryVisibility;